<template>
  <div class="yxt-biz-tag">
    <yxt-form :size="size">
      <yxt-form-item :error="error">
        <template v-if="!selectMode">
        <yxt-popover
          placement="bottom-start"
          trigger="manual"
          v-model="visibleMore"
        >
          <div slot="reference">
            <yxt-input
              :size="size"
              :style="{ width: width }"
              :readonly="!canInput"
              :class="{ 'is-error': error }"
              class="mr12"
              :placeholder="placeholder"
              :maxlength="maxlength"
              v-model="tagValue"
              :disabled="!canInput && !canSelect"
              @keydown.enter.prevent.native="createCurrentTag"
            >
              <i
                slot="suffix"
                v-if="canSelect"
                class="yxt-input__icon yxt-icon-more hand hover-primary-6"
                @click="showSelector"
              ></i>
            </yxt-input>
          </div>

          <div class="yxtbiz-tag__wrap">
            <yxt-scrollbar>
              <ul v-clickoutside="cancelRecommend" class="yxtbiz-tag_recommend">
                <li
                  :title="setTitle(item)"
                  class="ellipsis nowrap hover-bg-primary-1"
                  @click="selectItem(item)"
                  :class="createClass(item)"
                  :key="index"
                  v-for="(item, index) in searchList"
                >
                  <span v-html="item.tagName"></span>
                  <span v-if="!!item.groupId">【{{ item.groupName }}】</span>
                </li>
              </ul>
            </yxt-scrollbar>
          </div>
        </yxt-popover>
        <yxt-row class="yxtbiz-tag-selection" :gutter="5">
          <yxt-tag
            closable
            @close="deleteTag(tag)"
            class="yxtbiz-tag-selected"
            type="info"
            :key="index"
            v-for="(tag, index) in selected"
          >
            <yxt-svg
              width="25px"
              height="21px"
              class="yxtbiz-tag-new"
              v-if="tag.isNew"
              icon-class="new"
            />
            <span>{{ tag.tagName | format }}</span>
          </yxt-tag>
        </yxt-row>
        </template>
        <template v-else>
          <yxt-select
            :value="selected"
            @change="updateSelectVal"
            multiple
            :placeholder="placeholder"
            :size="size"
            :style="{ width: width }"
            :disabled="!canSelect"
            :class="{ 'is-error': error }"
            class="mr12"
            icon-name="more"
            hidden-option
            collapse-tags
            value-key="id"
            prop-label="tagName"
            clearable
            @visible-change="showSelector"
          >
            <template slot='tag' slot-scope='{ data }'>
              <span>{{ data.currentLabel }}</span>
            </template>
          </yxt-select>
        </template>
      </yxt-form-item>
    </yxt-form>
    <!-- dialog 模式 -->
    <yxtf-dialog
      v-if="type === 'dialog'"
      :visible.sync="dialogVisible"
      :title="title"
      width="640px"
      append-to-body
      :before-close="beforeClose"
      @close="close"
      @closed="closed"
    >
      <tag-selector v-if="dialogContentVisible" v-model="s_selected" :module="module"></tag-selector>
      <div slot="footer">
        <yxt-button plain @click="close">{{ $t('pc_biz_utility_btn_cancel') }}</yxt-button>
        <yxt-button @click="confirm" type="primary">{{ $t('pc_biz_utility_btn_confirm') }}</yxt-button>
      </div>
    </yxtf-dialog>
    <!-- drawer 模式 -->
    <yxt-drawer
      v-else
      :visible.sync="drawerVisible"
      :title="title"
      size="640px"
      destroy-on-close
      :before-close="beforeClose"
      @close="close"
    >
      <tag-selector v-model="s_selected" :module="module"></tag-selector>
      <div slot="footer">
        <yxt-button plain @click="close">{{
          $t('pc_biz_utility_btn_cancel')
        }}</yxt-button>
        <yxt-button @click="confirm" type="primary">{{
          $t('pc_biz_utility_btn_confirm')
        }}</yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>

<script>
import tagSelector from './tag-select';
import { searchTag, createTag, getTagSelectList, getEditType } from './service';
import { Drawer, Form, FormItem, Tag, Popover, Clickoutside } from 'yxt-pc';

const getTagName = name => {
  return name.replace(/<[^<>]+>/g, '');
};
export default {
  name: 'YxtbizTag',
  components: {
    tagSelector,
    YxtDrawer: Drawer,
    YxtForm: Form,
    YxtFormItem: FormItem,
    YxtTag: Tag,
    YxtPopover: Popover
  },
  props: {
    selectMode: { type: Boolean, default: false },
    module: {
      type: Number,
      required: true
    },
    maxlength: {
      type: Number,
      default: 30
    },
    width: {
      type: String,
      default: '250px'
    },
    size: {
      type: String,
      default: ''
    },
    count: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    type: { type: String, default: 'drawer' },
    clearAfterAdded: {
      type: Boolean,
      default: false
    },
    customPlaceHolder: String
  },
  data() {
    return {
      tagValue: '',
      error: '',
      drawerVisible: false, // 显示标签选择抽屉
      dialogVisible: false, // 显示标签选择弹窗
      dialogContentVisible: false, // 显示标签选择弹窗内容
      visibleMore: false, // 显示相关标签下拉
      selected: [],
      s_selected: [], // 选择列表备份
      singleList: {}, // 单选的标签组id列表
      searchList: [],
      canSelect: false,
      canInput: false
    };
  },
  computed: {
    formatedValue() {
      return this.tagValue ? this.tagValue.replace(/<[^<>]+>/g, '').trim() : '';
    },
    title() {
      return this.$t('pc_biz_utility_tit_selectTags');
    },
    placeholder() {
      if (this.customPlaceHolder) {
        return this.customPlaceHolder;
      }
      return this.$t('pc_biz_tag_tip_search');
    }
  },
  created() {
    this.init();
  },
  methods: {
    beforeClose(done) {
      let hasChange = !this.isSame(this.s_selected, this.selected);
      if (this.type !== 'dialog') {
        return done(hasChange);
      }
      if (hasChange) {
        return this.$confirm(this.$t('pc_comp_drawer_confirmCancel'), this.$t('pc_comp_drawer_msgCancel'), {
          confirmButtonText: this.$t('pc_comp_drawer_confirm'),
          cancelButtonText: this.$t('pc_comp_drawer_cancel'),
          type: 'warning'
        }).then(() => {
          done(true);
        }).catch(() => {
          done(false);
        });
      }
      return done(true);
    },
    isSame(source, target) {
      if (source.length !== target.length) return false;
      return source.every(item => {
        return !!target.find(node => node.id === item.id);
      });
    },
    init() {
      // 获取标签业务组编辑类型
      getEditType(this.module)
        .then(res => {
          this.canInput = !!res.canInput;
          this.canSelect = !!res.canSelect;
        })
        .catch(e => {
          console.log(e);
        });
      // 因为有搜索下拉，所以需要提前获取单选数据，用于在选择下拉选项时判断是否多选
      getTagSelectList({
        status: 1,
        tagType: this.module
      }).then(res => {
        res.datas.forEach(item => {
          if (item.choiceType === 1) {
            if (item.tags && item.tags.length > 0) {
              this.singleList[item.id] = [];
              item.tags.forEach(node => {
                this.singleList[item.id].push(node.id);
              });
            }
            // 单选
          }
        });
      });
    },
    showSelector(show = true) {
      if (!this.canSelect || !show) {
        // 如果标签业务不可选择
        return;
      }
      this.s_selected = [].concat(this.selected); // 传递数据专用
      if (this.type === 'dialog') {
        this.dialogVisible = true;
        this.dialogContentVisible = true;
      } else {
        this.drawerVisible = true;
      }
    },
    cancelRecommend() {
      // 点击元素外隐藏推荐列表
      this.visibleMore = false;
    },
    setTitle(tag) {
      return this.testCheck(tag)
        ? this.$t('pc_biz_utility_tip_tagSelected')
        : '';
    },
    createClass(tag) {
      // 不同li元素给予不同样式
      let classList = [];

      if (this.testCheck(tag)) {
        // 已选择标签，灰化
        classList.push('is-disabled');
      }
      return classList;
    },
    close() {
      this.drawerVisible = false;
      this.dialogVisible = false;
    },
    closed() {
      this.dialogContentVisible = false;
    },
    confirm() {
      this.selected = this.s_selected;
      this.updateSelected();
      this.close();
    },
    updateSelectVal(val) {
      this.selected = val;
      this.updateSelected();
    },
    updateSelected() {
      this.selected = this.selected.map(item => {
        item.tagName = getTagName(item.tagName);
        return item;
      });
      this.error = '';
      this.$emit('input', this.selected);
    },
    deleteTag(tag) {
      this.selected = this.selected.filter(item => item.id !== tag.id);
      this.updateSelected();
    },
    async createCurrentTag() {
      if (this.canSelect) {
        await this.create();
      } else {
        await this.addNewTag();
      }
      if (this.clearAfterAdded) this.tagValue = '';
    },
    async create() {
      this.visibleMore = false;
      let postData = {
        searchKey: this.formatedValue,
        tagType: this.module,
        generateType: -1,
        appendGroupInfo: true,
        status: 1 // 查询启用标签
      };

      try {
        // 检索标签是否存在
        let result = await searchTag(postData);

        let findTag = result.datas.filter(node => {
          return (
            this.$options.filters.format(node.tagName) === this.formatedValue
          );
        });

        if (findTag.length === 0) {
          // 不存在则创建
          return this.addNewTag();
        } else {
          // 存在
          // 判断是否在已选中列表中, 若存在，输出错误信息
          if (this.testCheck(findTag[0])) {
            this.error = this.$t('pc_biz_utility_tip_tagSelected');
            return Promise.reject();
          }

          this.addTag(findTag[0]);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async createTag() {
      let postData = {
        tagName: this.formatedValue,
        tagType: this.module,
        generateType: 1
      };

      return createTag(postData);
    },
    async addNewTag() {
      // 使用新增tag
      let resultTag = await this.createTag();

      if (this.testCheck(resultTag)) {
        this.error = this.$t('pc_biz_utility_tip_tagSelected');
        return Promise.reject();
      }

      if (resultTag && resultTag.id) {
        resultTag.tagName = this.formatedValue;
        resultTag.isNew = true;
        this.addTag(resultTag);
      }
    },
    selectItem(tag) {
      // 选择标签
      // 判断标签是否已在选中列表中
      let checked = this.testCheck(tag);
      if (checked) {
        return;
      }
      // 若不存在则添加入列表
      this.addTag(tag);

      this.visibleMore = false;
    },
    testCheck(item) {
      return !!this.selected.find(tag => item.id === tag.id);
    },
    addTag(tag) {
      if (!this.testCheck(tag)) {
        // 判断当前标签是否在只允许单选的便签组里面
        let groupId = tag.groupId;
        let groupTagIds = this.singleList[groupId];
        let inSingleGroup = groupTagIds
          ? this.selected.filter(item => groupTagIds.includes(item.id)).length >
            0
          : false;
        if (inSingleGroup) {
          this.$message({
            message: this.$t('pc_biz_utility_msg_singleGroupEror'),
            type: 'info'
          });
          // 去除选中列表中当前标签组其他选中标签，注释掉逻辑，以防之后需求变化
          // this.selected = this.selected.filter(item => item.groupId !== groupId);
          return;
        }
        this.selected.push(tag);
        this.updateSelected();
      }
    },
    searchTag() {
      let data = {
        searchKey: this.formatedValue,
        tagType: this.module,
        generateType: -1,
        appendGroupInfo: true,
        status: 1 // 查询启用标签
      };
      searchTag(data)
        .then(result => {
          this.searchList = result.datas;
          if (this.searchList.length > 0) {
            this.visibleMore = true;
          } else {
            this.visibleMore = false;
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  watch: {
    tagValue(v) {
      this.error = '';
      if (v.trim() !== '' && this.canSelect) {
        this.searchTag();
      }
    },
    value: {
      immediate: true,
      handler(v) {
        this.selected = v;
      }
    },
    error(v) {
      if (v) {
        this.$emit('error-show');
      } else {
        this.$emit('error-hide');
      }
    }
  },
  filters: {
    format(input) {
      return getTagName(input);
    }
  },
  directives: { Clickoutside }
};
</script>
